// extracted by mini-css-extract-plugin
export default {"tile":"LocalTile_tile__FvnEs"};